"use client";

import { useEffect, useRef, useState } from "react";

type MarkdownArticleProps = {
  html: string;
};

export const MarkdownArticle = ({ html }: MarkdownArticleProps) => {
  const [isMounted, setIsMounted] = useState(false);
  
  // Sanitize and ensure consistent HTML structure
  const sanitizedHtml = html?.trim() || "";

  // Mark as mounted after component has fully hydrated
  useEffect(() => {
    setIsMounted(true);
  }, []);

  // Only render content after mount to prevent hydration errors
  if (!isMounted) {
    return (
      <article className="prose prose-lg max-w-none prose-headings:font-bebas prose-headings:text-gray-900 prose-h1:text-5xl prose-h2:text-4xl prose-h3:text-3xl prose-h4:text-2xl prose-p:font-poppins prose-p:text-gray-700 prose-p:leading-relaxed prose-p:text-base prose-a:text-[#8100FF] prose-a:font-poppins prose-a:no-underline prose-a:hover:underline prose-strong:text-gray-900 prose-strong:font-poppins prose-strong:font-semibold prose-blockquote:border-l-4 prose-blockquote:border-[#8100FF] prose-blockquote:bg-gray-50 prose-blockquote:text-gray-700 prose-blockquote:pl-6 prose-blockquote:italic prose-blockquote:font-poppins prose-code:rounded-lg prose-code:bg-gray-100 prose-code:px-2 prose-code:py-1 prose-code:text-[#8100FF] prose-code:font-mono prose-pre:bg-gray-900 prose-pre:text-gray-100 prose-pre:text-sm prose-ul:list-disc prose-ul:font-poppins prose-ol:list-decimal prose-ol:font-poppins prose-li:my-2 prose-li:font-poppins prose-li:text-gray-700">
        <div suppressHydrationWarning />
      </article>
    );
  }

  return (
    <article className="prose prose-lg max-w-none prose-headings:font-bebas prose-headings:text-gray-900 prose-h1:text-5xl prose-h2:text-4xl prose-h3:text-3xl prose-h4:text-2xl prose-p:font-poppins prose-p:text-gray-700 prose-p:leading-relaxed prose-p:text-base prose-a:text-[#8100FF] prose-a:font-poppins prose-a:no-underline prose-a:hover:underline prose-strong:text-gray-900 prose-strong:font-poppins prose-strong:font-semibold prose-blockquote:border-l-4 prose-blockquote:border-[#8100FF] prose-blockquote:bg-gray-50 prose-blockquote:text-gray-700 prose-blockquote:pl-6 prose-blockquote:italic prose-blockquote:font-poppins prose-code:rounded-lg prose-code:bg-gray-100 prose-code:px-2 prose-code:py-1 prose-code:text-[#8100FF] prose-code:font-mono prose-pre:bg-gray-900 prose-pre:text-gray-100 prose-pre:text-sm prose-ul:list-disc prose-ul:font-poppins prose-ol:list-decimal prose-ol:font-poppins prose-li:my-2 prose-li:font-poppins prose-li:text-gray-700">
      <div 
        suppressHydrationWarning
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }} 
      />
    </article>
  );
};

